import {gql} from '@apollo/client';

export const itemStatusQueries = {
    ITEM_STATUSES_BY_BOARD_ID: gql`
        query ItemStatusesByBoardSlug($boardSlug: String!) {
            itemStatuses(where: {board: {slug: {eq: $boardSlug}}, active: {eq: true}}, order: [{order: ASC}]) {
                id
                title
                order
                color
                textColor
                statusType
                boardId
            }
        }
    `,
};
